var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPanelNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "660.667px",
    height: "660.667px",
    viewBox: "0 0 66.667 66.667",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "colorable",
    d: "M23.334,26.666c2.619,0,4.75-2.131,4.75-4.75s-2.131-4.75-4.75-4.75s-4.75,2.131-4.75,4.75S20.715,26.666,23.334,26.666z  M23.334,19.166c1.517,0,2.75,1.233,2.75,2.75s-1.233,2.75-2.75,2.75s-2.75-1.233-2.75-2.75S21.817,19.166,23.334,19.166z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "colorable",
    d: "M51.371,49.5c2.618,0,4.75-2.131,4.75-4.75S53.989,40,51.371,40c-2.619,0-4.75,2.131-4.75,4.75S48.751,49.5,51.371,49.5z  M51.371,42c1.517,0,2.75,1.232,2.75,2.75s-1.233,2.75-2.75,2.75c-1.518,0-2.75-1.232-2.75-2.75S49.854,42,51.371,42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "colorable",
    d: "M1.002,36.666c0.174,0,0.351-0.045,0.511-0.141l13.959-8.312c1.85,2.304,4.685,3.786,7.862,3.786 c2.771,0,5.282-1.124,7.106-2.938l12.514,10.15c-1.052,1.592-1.667,3.494-1.667,5.539c0,5.561,4.522,10.083,10.084,10.083 c5.561,0,10.084-4.522,10.084-10.083c0-2.852-1.194-5.424-3.104-7.26l8.195-15.097c0.264-0.485,0.084-1.092-0.401-1.356 c-0.487-0.262-1.092-0.084-1.355,0.402l-8.033,14.799c-1.562-0.99-3.404-1.572-5.385-1.572c-2.798,0-5.329,1.146-7.158,2.99 l-12.5-10.138c1.075-1.604,1.704-3.53,1.704-5.601c0-5.56-4.523-10.083-10.083-10.083s-10.083,4.523-10.083,10.083 c0,1.665,0.412,3.233,1.131,4.619L0.489,34.807c-0.475,0.283-0.63,0.896-0.348,1.371C0.329,36.492,0.661,36.666,1.002,36.666z  M51.371,36.666c4.458,0,8.084,3.626,8.084,8.083s-3.626,8.083-8.084,8.083s-8.084-3.626-8.084-8.083S46.913,36.666,51.371,36.666 z M23.334,13.833c4.457,0,8.083,3.626,8.083,8.083s-3.626,8.083-8.083,8.083s-8.083-3.626-8.083-8.083 S18.877,13.833,23.334,13.833z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPanelNode);
export default __webpack_public_path__ + "static/media/left-panel-node.4b6df3d5e0ca74585ad55f78006ed9a3.svg";
export { ForwardRef as ReactComponent };